/** A public result-preview entry beside the actual assignment/guardian workspace. */
export function LearningDemoEntry({ perspective }: { perspective: 'student' | 'family' }) {
  return (
    <section
      className="card-base space-y-3 border border-brand-sky/30 bg-wash-sky"
      aria-label="Preview school learning results"
    >
      <h2 className="section-title">See a complete learning example</h2>
      <p>
        Follow a fraction question through a student’s explanation, the teacher’s reviewed feedback
        and the guardian’s progress report. Fictional examples open separately and leave your work
        untouched.
      </p>
      <div className="flex flex-wrap gap-3">
        {['school', 'tutor'].map((kind) => (
          <a
            className="btn-pill-secondary"
            key={kind}
            target="_blank"
            rel="noopener noreferrer"
            href={`/try/lms/${kind}/${perspective}`}
          >
            {kind === 'school' ? 'School result example' : 'Independent tutor result example'} ↗
          </a>
        ))}
      </div>
    </section>
  );
}
